import { Refresh } from '@material-ui/icons';
import Column from '../Containers/Column';
import Row from '../Containers/Row';
import { cn } from '../../../utils';

const PageHeader = ({
  title,
  subtitle,
  onRefreshClick,
  className,
  subtitleClassName,
  containerClassName,
}: {
  title: string;
  subtitle?: string;
  onRefreshClick?: () => void;
  className?: string;
  subtitleClassName?: string;
  containerClassName?: string;
}) => {
  return (
    <Column className={cn('gap-2', containerClassName)}>
      <Row className="items-center gap-2">
        <HeaderText title={title} className={className} />
        {onRefreshClick && (
          <button onClick={onRefreshClick}>
            <Refresh className="text-secondary hover:scale-110 animated" />
          </button>
        )}
      </Row>
      {subtitle && (
        <SubtitleText subtitle={subtitle} className={subtitleClassName} />
      )}
    </Column>
  );
};

export default PageHeader;

const HeaderText = ({
  title,
  className,
  text,
}: {
  title?: string;
  className?: string;
  text?: string;
}) => {
  return (
    <h1 className={cn('font-bold text-black text-xl', className)}>
      {title || text || ''}
    </h1>
  );
};

const MediumText = ({ text, className }: { text: string; className?: string }) => {
  return <h1 className={cn('font-medium text-black text-sm', className)}>{text}</h1>;
};

const SubtitleText = ({
  subtitle,
  text,
  className,
  children,
  dir,
}: {
  subtitle?: string;
  text?: string;
  className?: string;
  children?: React.ReactNode;
  dir?: 'ltr' | 'rtl';
}) => {
  return (
    <p dir={dir} className={cn('text-labelText text-sm row gap-1', className)}>
      {subtitle ?? text} {children}
    </p>
  );
};
export { HeaderText, SubtitleText, MediumText };
